import { SWRFetcher } from '@commenda/utils';
import { EntitlementType } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';
import { TEntitlements } from './entitlement.types';

type EntitlementQueryParams = {
  companyId: number;
  entitlementType?: EntitlementType;
  entityId?: string;
};

function useEntitlements(params: EntitlementQueryParams) {
  const query = new URLSearchParams();
  query.append('companyId', params.companyId?.toString());
  if (params.entitlementType) {
    query.append('entitlementType', params.entitlementType);
  }
  if (params.entityId) {
    query.append('entityId', params.entityId);
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: TEntitlements;
    error?: unknown;
    mutate: KeyedMutator<TEntitlements>;
  } = useSWR(
    params.companyId ? `entitlements?${query}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useEntitlements };
